import { render, staticRenderFns } from "./Short_form_Customize_ExcellentRate.vue?vue&type=template&id=5fd40acd&scoped=true&"
import script from "./Short_form_Customize_ExcellentRate.vue?vue&type=script&lang=js&"
export * from "./Short_form_Customize_ExcellentRate.vue?vue&type=script&lang=js&"
import style0 from "./Short_form_Customize_ExcellentRate.vue?vue&type=style&index=0&id=5fd40acd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd40acd",
  null
  
)

export default component.exports